import React, { useState } from 'react'
import { Box, Button, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Switch, Typography } from '@mui/material'
import { Api, Architecture, CameraAlt, Chair, Palette, People, ShoppingCartOutlined } from '@mui/icons-material';

const Pricing = (props) => {

  const [isAnnual, setIsAnnual] = useState(false);

  const handleChange = () => {
    setIsAnnual(!isAnnual);
  }

  return (
    <Box>
      <Box sx={{display: "flex", flexWrap: "wrap", justifyContent: "center"}}>
        <Box sx={{m: 1,}}>
          <Paper sx={{maxWidth: 650, minWidth: 300, p: 4, width: "25rem",}}>
            <Box sx={{alignItems: "center", display: "flex", flexWrap: "wrap", justifyContent: "space-between"}}>
              <Typography
                elevation={2}
                fontWeight={600}
                variant="h4"
              >
                Basic
              </Typography>
            </Box>
            <Box sx={{alignItems: "center", display: "flex", height: 40, my: 1,}}>
              <Typography fontSize={20} textTransform="uppercase">Free</Typography>
            </Box>
            <Typography fontSize={14}>Design your home for free using Personal Architect on your own, or with others.</Typography>
            <Box>
              <List>
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <Palette />
                    </ListItemIcon>
                    <ListItemText primary="Design Tools" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <Chair />
                    </ListItemIcon>
                    <ListItemText primary="Free Catalog" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <People />
                    </ListItemIcon>
                    <ListItemText primary="Online Collaboration" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <CameraAlt />
                    </ListItemIcon>
                    <ListItemText primary="Photo-Realistic Rendering" />
                  </ListItemButton>
                </ListItem>
              </List>
            </Box>
            <Button href="https://designer.personalarch.com" fullWidth variant="contained">Start a Project</Button>
          </Paper>
        </Box>
        <Box sx={{m: 1,}}>
          <Paper elevation={5} sx={{border: "1px solid red", maxWidth: 650, minWidth: 300, p: 4, width: "25rem",}}>
            <Box sx={{alignItems: "center", display: "flex", flexWrap: "wrap", justifyContent: "space-between"}}>
              <Typography
                component="span"
                elevation={2}
                fontWeight={400}
                sx={{ backgroundColor: "#b71c1c", borderRadius: "4px", color: "#ffffff", pl: .85, pr: .85 }}
                variant="h4"
              >
                Pro
              </Typography>
              <Box sx={{alignItems: "center", display: "flex",}}> 
                <Typography fontSize={12} fontWeight={500} textTransform="uppercase">Monthly</Typography>
                <Switch
                  checked={isAnnual}
                  onChange={handleChange}
                  inputProps={{ 'aria-label': 'controlled' }}
                />
                <Typography fontSize={12} fontWeight={500} textTransform="uppercase">Annually</Typography>
              </Box>
            </Box>
            <Box sx={{alignItems: "baseline", display: "flex", height: 40, my: 1,}}>
              <Typography fontWeight={500} variant="h4">${!isAnnual ? "9.95" : "115"}</Typography>
              <Typography sx={{mx: .5,}}>per</Typography>
              <Typography>{!isAnnual ? "Month" : "Year"}</Typography>
            </Box>
            <Typography fontSize={14}>Unlimited access to premium content and features. All of the features of Basic plus:</Typography>
            <Box>
              <List>
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <Box
                        component="img"
                        src={
                          process.env.NODE_ENV === 'development' ? 
                            "/assets/svg/icons/grey/ai-design-assistant.svg" : 
                            "/wp-content/themes/personal-architect/assets/svg/icons/grey/ai-design-assistant.svg"
                        }
                        sx={{ height: 24, width: 24, }}
                      />
                    </ListItemIcon>
                    <ListItemText primary="AI Design Assistant" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <Box
                        component="img"
                        src={
                          process.env.NODE_ENV === 'development' ? 
                            "/assets/svg/icons/grey/product-factory.svg" : 
                            "/wp-content/themes/personal-architect/assets/svg/icons/grey/product-factory.svg"
                        }
                        sx={{ height: 24, width: 24, }}
                      />
                    </ListItemIcon>
                    <ListItemText primary="Product Factory" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <ShoppingCartOutlined />
                    </ListItemIcon>
                    <ListItemText primary="Shopping Cart" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <Api />
                    </ListItemIcon>
                    <ListItemText primary="3rd Party Integrations" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <Architecture />
                    </ListItemIcon>
                    <ListItemText primary="Collections" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <Box
                        component="img"
                        src={
                          process.env.NODE_ENV === 'development' ? 
                            "/assets/svg/icons/grey/environment-settings.svg" : 
                            "/wp-content/themes/personal-architect/assets/svg/icons/grey/environment-settings.svg"
                        }
                        sx={{ height: 24, width: 24, }}
                      />
                    </ListItemIcon>
                    <ListItemText primary="Environment Settings" />
                  </ListItemButton>
                </ListItem>
              </List>
            </Box>
            <Button href={!isAnnual ? "https://xg205.infusionsoft.com/app/manageCart/addProduct?productId=546&subscriptionPlanId=100" : "https://xg205.infusionsoft.com/app/manageCart/addProduct?productId=546&subscriptionPlanId=102"} fullWidth variant="contained">Subscribe</Button>
          </Paper>
        </Box>
      </Box>
    </Box>
  )
}

export default Pricing